import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../../api/axios'
import endpoints from '../../../api/endpoints'
import { extractApiErrorMessage } from '../../../utils/apiError'
import { ProfileInfo } from '../profileSlice'

export interface ManualTimeOffProfileState {
  data: ProfileInfo | null
  loading: boolean
  error: string | null
  initialized: boolean
}

const initialState: ManualTimeOffProfileState = {
  data: null,
  loading: false,
  error: null,
  initialized: false,
}

export const fetchManualTimeOffProfile = createAsyncThunk(
  'manualTimeOffProfile/fetchManualTimeOffProfile',
  async (_, { rejectWithValue, signal }) => {
    try {
      const options: any = {
        signal,
        manualTimeOffProfileRequest: true,
      }

      const response = await api.get(endpoints.profile, options)

      return response.data
    } catch (error: any) {
      return rejectWithValue(
        extractApiErrorMessage(error, 'Failed to fetch Manual Time Off profile')
      )
    }
  }
)

const manualTimeOffProfileSlice = createSlice({
  name: 'manualTimeOffProfile',
  initialState,
  reducers: {
    clearManualTimeOffProfile: (state) => {
      state.data = null
      state.loading = false
      state.error = null
      state.initialized = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchManualTimeOffProfile.pending, (state) => {
        state.loading = true
        state.error = null
        state.initialized = false
      })
      .addCase(fetchManualTimeOffProfile.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
        state.initialized = true
      })
      .addCase(fetchManualTimeOffProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
        state.initialized = true
      })
  },
})

export const { clearManualTimeOffProfile } = manualTimeOffProfileSlice.actions

export const manualTimeOffProfileData = (state: {
  manualTimeOffProfile: ManualTimeOffProfileState
}) => state.manualTimeOffProfile.data

export default manualTimeOffProfileSlice.reducer
